import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { User } from "firebase/auth";
import React from "react";
import { DBUser, getRole } from "../../ostertalertypes";

interface ITableUsers extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    users : {user: User | null, userDetails: DBUser}[]
    getActionBtn: (user: DBUser) => JSX.Element | undefined
}


export const TableUsers: React.FC<ITableUsers> = (props) => {
    return(
        <TableContainer component={Paper}>
        <Table sx={{  }} size="small">
          <TableHead>
            <TableRow className="bg-blue-600 text-white  font-medium">
              <TableCell className="text-white">Vorname</TableCell>
              <TableCell className="text-white">Nachname</TableCell>
              <TableCell className="text-white">Rolle</TableCell>
              <TableCell className="text-white" align="right">E-Mail</TableCell>
              <TableCell className="text-white" align="right">Telefon</TableCell>
              <TableCell className="text-white" align="right">Buchungen</TableCell>
              <TableCell className="text-white" align="right">Aktion</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {props.users.map((user, i) => (
              <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell component="th" scope="row">{user.userDetails?.firstname || ""}</TableCell>
                  <TableCell component="th" scope="row">{user.userDetails?.lastname || ""}</TableCell>
                  <TableCell align="right">{user.userDetails.role !== undefined ? getRole(user.userDetails.role): ""}</TableCell>
                  <TableCell align="right">{user.user?.email || ""}</TableCell>
                  <TableCell align="right">{user.user?.phoneNumber || ""}</TableCell>
                  <TableCell align="right">{user.userDetails.bookingCount}</TableCell>
                  <TableCell align="right">
                    {props.getActionBtn(user.userDetails)}
                  </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
        )
}
